/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import JournalEntryBreadcrumbs from 'domain/finance/journalEntry/shared/JournalEntryBreadcrumbs';

const SingleJournalEntryBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useJournalEntryUrl();
  const id = data.getValueBySource('id');
  const displayedName = data.getValueBySource('id');

  return (
    <JournalEntryBreadcrumbs>
      <SingleBreadcrumbItem entity={displayedName} link={getSingleEntityUrl(id)} />
      {children}
    </JournalEntryBreadcrumbs>
  );
};

export default SingleJournalEntryBreadcrumbs;
